import { atom } from 'jotai';
import type { ComponentType } from 'react';
import { jotaiStore } from '@/atoms/store';
import type { ConfirmOptions, ModalProps } from './types';

type BaseEntry = {
    id: number;
    pending: boolean;
    dismissOnNavigate: boolean;
    triggerElement: Element | null;
};

export type ConfirmEntry = BaseEntry & {
    kind: 'confirm';
    options: ConfirmOptions;
    resolve: (value: boolean) => void;
};

export type CustomEntry = BaseEntry & {
    kind: 'custom';
    Component: ComponentType<ModalProps<unknown> & Record<string, unknown>>;
    payload: Record<string, unknown>;
    resolve: (value: unknown) => void;
};

export type ModalEntry = ConfirmEntry | CustomEntry;

export const modalStackAtom = atom<ModalEntry[]>([]);

let nextId = 1;
export const nextModalId = () => nextId++;

export const pushEntry = (entry: ModalEntry) => {
    jotaiStore.set(modalStackAtom, [...jotaiStore.get(modalStackAtom), entry]);
};

export const removeEntry = (id: number) => {
    jotaiStore.set(
        modalStackAtom,
        jotaiStore.get(modalStackAtom).filter(e => e.id !== id),
    );
};

export const setPending = (id: number, pending: boolean) => {
    jotaiStore.set(
        modalStackAtom,
        jotaiStore.get(modalStackAtom).map(e => (e.id === id ? { ...e, pending } : e)),
    );
};

export const clearStack = () => {
    const cur = jotaiStore.get(modalStackAtom);
    for (const e of cur) {
        if (e.kind === 'confirm') e.resolve(false);
        else e.resolve(undefined);
    }
    jotaiStore.set(modalStackAtom, []);
};
